import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { IWorkflowEdge, WorkflowEdge } from 'component.workflow.core';
import { ApiService } from './api.service';
import { PlatformService } from 'buzzyears.ui';

@Injectable()
export class WorkflowEdgeService extends ApiService {

  constructor(http: HttpClient, platformService: PlatformService) {
    super(http, platformService);
  }

  bulkAction(workflowId: string, data: any): Observable<any> {
    return this.http
      .post(this.toUrl('contextual-bulk'), {
        context: {
          workflowId: workflowId
        },
        items: data
      }, this.requestOptions)
      .catch(this.manageError);
  }

  duplicateFromToWorkflow(fromWorkflowId: string, toWorkflowId: string): Observable<any> {
    return this.forWorkflow(fromWorkflowId).mergeMap(list => {
      const newList = list.map(item => {
        item.workflowId = toWorkflowId;
        item.duplicateOf = item.id;
        item.id = undefined;

        return item;
      });

      return this.bulkAction(toWorkflowId, newList);
    });
  }

  forWorkflow(workflowId: string): Observable<any> {
    return this.http
      .post(this.toUrl('search'), {
        paging: { limit: 9999 },
        sort: {
          createdAt: 'asc',
          _id: 'asc'
        },
        filter: {
          workflowId: workflowId
        }
      }, this.requestOptions)
      .map((raw: any) => raw.docs)
      .catch(this.manageError);
  }

  update(data: IWorkflowEdge): Observable<any> {
    return this.http
      .put(this.toUrl(), data, this.requestOptions)
      .map((raw: any) => new WorkflowEdge(raw))
      .catch(this.manageError);
  }

  remove(id: string): Observable<any> {
    return this.http
      .delete(this.toUrl(id), this.requestOptions)
      .map((raw: any) => new WorkflowEdge(raw))
      .catch(this.manageError);
  }

  get(id: string): Observable<any> {
    return this.http
      .get(this.toUrl(id), this.requestOptions)
      .map((raw: any) => new WorkflowEdge(raw))
      .catch(this.manageError);
  }

  create(workflowEdge: IWorkflowEdge): Observable<any> {
    return this.http
      .post(this.toUrl(), workflowEdge, this.requestOptions)
      .map((raw: any) => new WorkflowEdge(raw))
      .catch(this.manageError);
  }

  protected toUrl(...parts: string[]): string {
    return super.toUrl('workflow-edge', ...parts);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/workflow-edge.service.ts